import { Outlet, RouteObject } from "react-router-dom";
import { ParallaxProvider } from "react-scroll-parallax";

import { PATHS } from "../paths";

import LandingPage from "@app/LandingPage/LandingPage";
import NotFound from "@app/NotFound/NotFound";

export const appRoutes: RouteObject = {
  element: (
    <ParallaxProvider>
      <Outlet />
    </ParallaxProvider>
  ),
  children: [
    {
      path: PATHS.main.path,
      element: LandingPage
    },
    {
      path: PATHS.notFound.path,
      element: NotFound
    }
  ]
};
